import { render } from "./dhMenu.vue?vue&type=template&id=ec8672e6&scoped=true"
import script from "./dhMenu.vue?vue&type=script&lang=js"
export * from "./dhMenu.vue?vue&type=script&lang=js"

import "./dhMenu.vue?vue&type=style&index=0&id=ec8672e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8672e6"]])

export default __exports__